import {
    SearchableSelect,
    SearchableSelectWrapperProps,
} from "components/UI/Selects/SearchableSelect/SearchableSelect";

import { useFormFieldTypeSelectOptions } from "./useFormFieldTypeSelectOptions";

export const FormFieldTypeSelectSearchable = (props: SearchableSelectWrapperProps) => {
    const hookResult = useFormFieldTypeSelectOptions();

    return (
        <SearchableSelect
            hookResult={hookResult}
            translationNamespace="forms.general-fields.type"
            {...props}
            size={props.size ?? "middle"}
        />
    );
};
